import {
  AuthorizationContextInput,
  ControllerInput,
  Resource,
} from "@examspark/types";

import { GraphQLAPI } from "../../client";

export const deleteClassroomActivity = async (variables: {
  input: ControllerInput;
  authorizationContext?: AuthorizationContextInput;
}) => {
  return GraphQLAPI.client.query<{
    updateResource: Resource;
  }>({
    query: /* GraphQL */ `
      mutation DeleteClassroomActivityAction(
        $input: ControllerInput!
        $authorizationContext: AuthorizationContextInput
      ) {
        deleteClassroomActivityAction(
          input: $input
          authorizationContext: $authorizationContext
        ) {
          id
          sk
          workspaceId
          schemaVersion
          createdAt
          creatorId
          updatedAt
          resourceId
          __typename
        }
      }
    `,
    variables,
  });
};
